import { ArrowRight } from 'lucide-react';

import { Button } from '@/components/common/Button/Button';

type SourceLinkProps = {
  href: string;
  label: string;
  external?: boolean;
};

export function SourceLink({ href, label, external = true }: SourceLinkProps): JSX.Element {
  return (
    <Button href={href} external={external} variant="ghost" size="sm">
      <span>{label}</span>
      <ArrowRight size={14} />
    </Button>
  );
}
